module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "gallery"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('swiper', {
    ref: "swiperTop",
    staticClass: "gallery-top",
    attrs: {
      "options": _vm.swiperOptionTop
    }
  }, [_vm._l((_vm.pics), function(pic) {
    return _c('swiper-slide', {
      key: pic,
      style: ('background-image:url(' + pic + ');')
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-button-white",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev swiper-button-white",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  })], 2), _vm._v(" "), _c('swiper', {
    ref: "swiperThumbs",
    staticClass: "gallery-thumbs",
    attrs: {
      "options": _vm.swiperOptionThumbs
    }
  }, _vm._l((_vm.pics), function(pic) {
    return _c('swiper-slide', {
      key: pic,
      style: ('background-image:url(' + pic + ');')
    })
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53b3a9a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = 100
// module chunks = 0